import React, { useEffect } from 'react';
import { getEnv } from '@config';

const { metrixUri, orgId } = getEnv();

/**
 * Inserts ejs for Cybersource api-fraud
 * @param {*} sessionId string without space
 */
const MetrixApi = ({ sessionId }) => {
  useEffect(() => {
    if (sessionId) {
      const script = document.createElement(`script`);
      script.src = `${metrixUri}/fp/tags.js?org_id=${orgId}&session_id=falabella_validacion${sessionId}`;
      document.head.append(script);
    }
  }, [sessionId]);
  return '';
};

export default React.memo(MetrixApi);
